var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initVerticalMenu = /* @__PURE__ */ __name(($el, $refs) => {
  window.Alpine.store("verticalMenu", {
    id: "",
    setId(value) {
      this.id = value;
    }
  });
  const verticalMenu = window.Alpine.store("verticalMenu");
  window.Alpine.magic("verticalMenu", () => verticalMenu);
  window._stores["verticalMenu"] = verticalMenu;
  const submenus = Array.from($el.querySelectorAll("[data-vertical-submenu]")).map(
    (el) => el.dataset.verticalSubmenu
  );
  const links = $el.querySelectorAll("nav a");
  links?.forEach((link) => {
    const handle = link?.textContent.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map((x) => x.toLowerCase()).join("-") ?? "";
    if (submenus.indexOf(handle) > -1) {
      link?.classList?.add("has_submenu");
      link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        links.forEach(
          (el) => el.classList.toggle(
            "active",
            el.textContent?.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map((x) => x.toLowerCase()).join("-") === handle
          )
        );
        verticalMenu.setId(handle);
        const backButton = $el?.querySelector(
          `[data-vertical-submenu="${handle}"] [data-back-button]`
        );
        if (backButton) {
          backButton.innerHTML = backButton.getAttribute("data-content")?.replace("[handle]", link.textContent);
        }
      });
    }
    if (link?.href?.includes("#megamenu--")) {
      const value = link.href.split("#megamenu--")[1];
      if (document.querySelector(`[data-megamenu="${value}"]`)) {
        link?.classList?.add("has_submenu");
      }
    }
  });
  window.Alpine.effect(() => {
    if (verticalMenu.id === "") {
      links.forEach((link) => link.classList.remove("active"));
    }
  });
}, "initVerticalMenu");
window._sections["initVerticalMenu"] = initVerticalMenu;
